"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.OneDriveSharePointItemType = exports.declarativeAgentInstructionFileName = exports.sampleDefaultRetryLimits = exports.sampleConcurrencyLimits = exports.oldPlaceholderDelimiters = exports.placeholderDelimiters = exports.commonTemplateName = exports.componentName = exports.errorSource = exports.templateFileExt = exports.sampleDefaultTimeoutInMs = exports.defaultTimeoutInMs = exports.defaultTryLimits = void 0;
exports.defaultTryLimits = 1;
exports.defaultTimeoutInMs = 20000;
exports.sampleDefaultTimeoutInMs = 40000;
exports.templateFileExt = ".tpl";
exports.errorSource = "GEN";
exports.componentName = "generator";
exports.commonTemplateName = "common";
exports.placeholderDelimiters = ["{{", "}}"];
exports.oldPlaceholderDelimiters = ["{%", "%}"];
exports.sampleConcurrencyLimits = 20;
exports.sampleDefaultRetryLimits = 2;
exports.declarativeAgentInstructionFileName = "instruction.txt";
var OneDriveSharePointItemType;
(function (OneDriveSharePointItemType) {
    OneDriveSharePointItemType["File"] = "File";
    OneDriveSharePointItemType["Folder"] = "Folder";
    OneDriveSharePointItemType["Site"] = "Site";
})(OneDriveSharePointItemType = exports.OneDriveSharePointItemType || (exports.OneDriveSharePointItemType = {}));
//# sourceMappingURL=constant.js.map